export class NavbarScrollAnimation {
  async init() {
    jQuery('document').ready(function () {

      console.log('jquery');
    });

    jQuery(window).scroll(function () {
      if (jQuery(document).scrollTop() > 200) {
        jQuery('.quarta-primary-navigation').addClass('navbar-animate');
      } else {
        jQuery('.quarta-primary-navigation').removeClass('navbar-animate');
      }
    });


    // Disable animation on resize
    jQuery(window).resize( function() {
      jQuery('.page-template-homepage #menu-main-menu ').addClass('animation-stopped');
      jQuery('.page-template-homepage .site-description').addClass('animation-stopped');
    } );
  }
}